import { render, staticRenderFns } from "./MaterialDbmSkuEdit.vue?vue&type=template&id=006933ca&scoped=true&"
import script from "./MaterialDbmSkuEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialDbmSkuEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006933ca",
  null
  
)

export default component.exports